import { CommonModule, registerLocaleData } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module'
import localePt from '@angular/common/locales/pt';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { LoaderService } from './shared/loader.service'
import { LoaderComponent } from './shared/loader/loader.component';
import { LoaderInterceptor } from './shared/loader/loader.interceptor';
import { SharedModule } from './shared/shared.module'
import { AuthGuardService } from './guards/auth-guard.service';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AtribuicaoComponent } from './pages/atribuicao/atribuicao.component';
import { VersoesComponent } from './pages/versoes/versoes.component';
import { RelatorioComponent } from './pages/versoes/relatorio/relatorio.component';
import { ComparacaoComponent } from './pages/versoes/comparacao/comparacao.component';
import { HelpComponent } from './pages/veiculo/orcamento/help-list/help/help.component';
import { SelecionarEmpresaPerfilComponent } from './pages/selecionar-empresa-perfil/selecionar-empresa-perfil.component';
import { ChamadosModule } from './pages/chamados/chamados.module';
import { RedefinirSenhaComponent } from './pages/redefinir-senha/redefinir-senha.component';
import { LoginSigaComponent } from './pages/login-siga/login-siga.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ModalModule } from 'ngx-bootstrap/modal';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    AtribuicaoComponent,
    VersoesComponent,
    RelatorioComponent,
    ComparacaoComponent,
    HelpComponent,
    SelecionarEmpresaPerfilComponent,
    RedefinirSenhaComponent,
    LoginSigaComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    CurrencyMaskModule,
    ChamadosModule,
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    ModalModule.forRoot(),
  ],
   exports: [
    SharedModule,
    CommonModule
   ],
  providers: [
    LoaderService,
    AuthGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
